<template>
  <v-app :dark="darkMode">
    <!-- Barra superior -->
    <AppbarView></AppbarView>

    <v-container class="py-5">
      <v-row justify="center">
        <v-col cols="12" md="8" lg="6">
          <v-card class="pa-4" outlined>
            <!-- Encabezado -->
            <v-card-title class="text-h5 font-weight-bold">
              Información del Usuario
            </v-card-title>
            <v-divider></v-divider>

            <!-- Contenido -->
            <v-card-text>
              <v-list dense>
                <!-- Mostramos los datos del usuario con estilo de app bancaria -->
                <v-list-item v-for="(value, key) in user" :key="key">
                  <v-row align="center" class="my-3">
                    <v-col cols="4" class="text-right">
                      <v-icon color="primary">{{ getIconForField(key) }}</v-icon>
                    </v-col>
                    <v-col cols="8">
                      <v-row align="center">
                        <v-col>
                          <v-list-item-title class="font-weight-bold">{{ formatLabel(key) }}:</v-list-item-title>
                        </v-col>
                        <v-col>
                          <v-list-item-subtitle>{{ value }}</v-list-item-subtitle>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-list-item>

                <!-- Estado del usuario (activo) -->
                <v-chip color="green" text-color="white">Activo</v-chip>
              </v-list>
            </v-card-text>

            <!-- Botones (Sin botones de acción en este ejemplo) -->
            <v-card-actions>
              <!-- Puedes agregar botones como "Editar perfil" si es necesario -->
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>

      <!-- Navegación inferior -->
      <v-container>
        <BottomNavigation></BottomNavigation>
      </v-container>
    </v-container>
  </v-app>
</template>

<script>
import AppbarView from '../appbar/appbarView.vue';
import BottomNavigation from '../submenu/BottomNavigation.vue';

export default {
  components: { AppbarView, BottomNavigation },
  name: 'DatosUsuarioview',
  data() {
    return {
      darkMode: false, // Variable para alternar entre modo oscuro y claro
      user: {}, // Datos del usuario
    };
  },
  methods: {
    obtenerDatos() {
  const user = JSON.parse(localStorage.getItem("user"));
  if (user) {
    // Extraemos solo el correo y el ID del cliente
    this.user = {
      email: user.email,
      cliente: user.cliente
    };
  }
},

    // Función de iconos por campo
    getIconForField(field) {
      const icons = {
        cliente: 'mdi-account-circle',
        email: 'mdi-email',
        address: 'mdi-map-marker',
        phone: 'mdi-phone',
        gender: 'mdi-gender-male-female',
        registrationDate: 'mdi-calendar',
      };
      return icons[field] || 'mdi-information';
    },

    // Función para formato de la etiqueta
    formatLabel(field) {
      const labels = {
        cliente: 'Cliente ID MV',
        email: 'Correo Electrónico',
        address: 'Dirección',
        phone: 'Teléfono',
        gender: 'Género',
        registrationDate: 'Fecha de Registro',
      };
      return labels[field] || field.charAt(0).toUpperCase() + field.slice(1);
    },
  },

  mounted() {
    this.obtenerDatos();
  }
};
</script>

<style scoped>
.v-card {
  margin-top: 40px;
  background-color: #ffffff;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  border-radius: 12px;
  padding: 20px;
}

.text-h5 {
  color: #3f51b5;
}

.v-chip {
  margin-top: 20px;
}

.v-list-item {
  transition: all 0.3s ease;
}

.v-list-item:hover {
  background-color: #f1f1f1;
}

.v-row {
  margin-bottom: 20px;
}

.v-col .v-list-item-title {
  color: #333;
}

.v-col .v-list-item-subtitle {
  font-weight: bold;
  color: #555;
}

.v-row .mdi {
  font-size: 24px;
  margin-right: 12px;
}

.v-divider {
  margin: 16px 0;
}

.v-chip {
  margin-top: 20px;
  font-weight: bold;
  font-size: 14px;
}

</style>
